import FilterProvider from "components/FilterProvider";
import BookingForm from "features/bookings/BookingForm";
import { CommissionReportView } from "features/commission-reports";
import ExchangeRateProvider from "features/exchange-rates/ExchangeRateProvider";
import { PartnerFeedNewsView } from "features/partner-feeds";
import PartnerBookingList from "features/Partner/Bookings/PartnerBookingList";
import PartnerContact from "features/Partner/Contact/PartnerContact";
import PartnerHome from "features/Partner/Home/PartnerHome";
import PartnerStatistics from "features/Partner/Statistics/PartnerStatistics";
import ProfileForm from "features/profile/ProfileForm";
import { WebSocketProvider } from "features/websoket/WebSocketProvider";
import PartnerLayout from "layouts/Partner/PartnerLayout";
import PageNotFound from "pages/page-not-found/PageNotFound";
import { Navigate, Route, Routes } from "react-router-dom";

export default function PartnerRouter() {
  const initialPath = "/";

  return (
    <WebSocketProvider>
      <ExchangeRateProvider>
        <Routes>
          <Route path="/login" element={<Navigate to={initialPath} />} />
          <Route path="/" element={<PartnerLayout />}>
            <Route path="" element={<PartnerHome />} />

            <Route path="bookings">
              <Route
                path=""
                element={
                  <FilterProvider id="partner.bookings" storageType="session">
                    <PartnerBookingList />
                  </FilterProvider>
                }
              />
              <Route path=":booking_id" element={<BookingForm />} />
            </Route>

            <Route path="statistics" element={<PartnerStatistics />} />
            <Route path="news" element={<PartnerFeedNewsView />} />
            <Route path="contact" element={<PartnerContact />} />
            <Route
              path="commission-report"
              element={<CommissionReportView />}
            />
            <Route path="profile" element={<ProfileForm />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
      </ExchangeRateProvider>
    </WebSocketProvider>
  );
}
